import AppendingContentWrapper from './AppendingContentWrapper'
import BulletPoints from './BulletPoints'
import Catchword from './Catchword'
import EverythingWrapper from './EverythingWrapper'
import ExtraDataWrapper from './ExtraDataWrapper'
import Gradient from './Gradient'
import InnerTextWrapper from './InnerTextWrapper'
import Label from './Label'
import Logo from './Logo'
import NewstickerHorizontal from './Newsticker/Horizontal'
import NewstickerVertical from './Newsticker/Vertical'
import OuterTextWrapper from './OuterTextWrapper'
import OuterWrapper from './OuterWrapper'
import PromoIndicator from './PromoIndicator'
import PromoLabel from './PromoLabel'
import SportsTiles from './SportsTiles'
import Subtitle from './Subtitle'
import Swisslos from './Swisslos'
import TextLine from './TextLine'
import TextWrapper from './TextWrapper'
import TileLeftHalf from './TileLeftHalf'
import TileLiveStatusTitle from './TileLiveStatusTitle'
import TileMiddleInfo from './TileMiddleInfo'
import TileRightHalf from './TileRightHalf'
import TileScore from './TileScore'
import TileStatusTitle from './TileStatusTitle'
import TileTeamLogo from './TileTeamLogo'
import TileTeamName from './TileTeamName'
import TileWrapper from './TileWrapper'
import Title from './Title'
import VideoInfo from './VideoInfo'

const exports = {
  AppendingContentWrapper,
  BulletPoints,
  Catchword,
  EverythingWrapper,
  ExtraDataWrapper,
  Gradient,
  InnerTextWrapper,
  Label,
  Logo,
  NewstickerHorizontal,
  NewstickerVertical,
  OuterTextWrapper,
  OuterWrapper,
  PromoIndicator,
  PromoLabel,
  SportsTiles,
  Subtitle,
  Swisslos,
  TextLine,
  TextWrapper,
  TileLeftHalf,
  TileLiveStatusTitle,
  TileMiddleInfo,
  TileRightHalf,
  TileScore,
  TileStatusTitle,
  TileTeamLogo,
  TileTeamName,
  TileWrapper,
  Title,
  VideoInfo,
}

export default exports
